export default Object.freeze({
  Search: 'search',
  Add: 'add',
  Modify: 'modify',
  Activate: 'activate',
  Deactivate: 'deactivate',
  Remove: 'remove',
  Count: 'count',
  CancelDelegation: 'cancel-delegation',
});
